export default {
  CONTACT: {
    CATEGORY_NAME: 'contact',
    ACTIONS: {
      OPEN_DIRECTIONS: 'open-directions',
      CALL: 'call',
      WEBSITE: 'website',
      SUBMIT: 'submit',
      FACEBOOK: 'facebook',
      TWITTER: 'twitter',
      INSTAGRAM: 'instagram',
      YELP: 'yelp',
    },
  },
  SHARE: {
    CATEGORY_NAME: 'share',
    ACTIONS: {
      FACEBOOK: 'facebook',
      TWITTER: 'twitter',
    },
  },
  NAVIGATION: {
    CATEGORY_NAME: 'navigation',
    ACTIONS: {
      CHANGE_VIEW: 'change-view',
      OPEN_MODAL: 'open-modal',
      EXPAND: 'expand-ad-unit',
    },
  },
};
